module.exports = __webpack_public_path__ + "img/hamburger-icon.6bdf0500.svg";